import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper, Stack, Chip, TextField, Button, FormControlLabel, Checkbox, MenuItem, Divider } from '@mui/material';
import { api } from '../services/api';

const STATUSES = ['Open', 'InProgress', 'WaitingOnCustomer', 'Resolved', 'Closed'];

export default function TicketDetailPage() {
  const { id } = useParams();
  const [t, setT] = useState(null);
  const [reply, setReply] = useState('');
  const [internal, setInternal] = useState(false);
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => api.get(`/api/tickets/${id}`).then(r => { setT(r.data); setStatus(r.data.status); });
  useEffect(() => { load(); }, [id]); // eslint-disable-line

  const send = async () => {
    if (!reply.trim()) return;
    setBusy(true);
    try { await api.post(`/api/tickets/${id}/messages`, { body: reply, isInternal: internal }); setReply(''); setInternal(false); load(); }
    finally { setBusy(false); }
  };

  const changeStatus = async () => {
    if (status === t.status) return;
    await api.post(`/api/tickets/${id}/status`, { newStatus: status });
    load();
  };

  if (!t) return <Typography>Loading…</Typography>;
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
        <Typography variant="h4">{t.ticketNumber}</Typography>
        <Chip label={t.status} />
        <Chip label={t.priority} color="warning" />
      </Stack>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">{t.title}</Typography>
        {t.description && <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>{t.description}</Typography>}
        <Stack direction="row" spacing={2} mt={2}>
          <TextField select label="Status" value={status} onChange={(e) => setStatus(e.target.value)} size="small" sx={{ minWidth: 200 }}>
            {STATUSES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
          <Button variant="outlined" onClick={changeStatus} disabled={status === t.status}>Update status</Button>
        </Stack>
      </Paper>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>Conversation</Typography>
        <Stack spacing={1} divider={<Divider />}>
          {(t.messages || []).map(m => (
            <Box key={m.id} sx={{ bgcolor: m.isInternal ? '#fff8e1' : 'transparent', p: 1, borderRadius: 1 }}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="caption">{m.authorName || m.authorEmail} · {m.authorType}{m.isInternal ? ' · internal' : ''}</Typography>
                <Typography variant="caption">{new Date(m.createdAt).toLocaleString()}</Typography>
              </Stack>
              <Typography sx={{ whiteSpace: 'pre-wrap', mt: 0.5 }}>{m.body}</Typography>
            </Box>
          ))}
        </Stack>
      </Paper>
      <Paper sx={{ p: 2 }}>
        <Stack spacing={1}>
          <TextField placeholder="Type a reply…" multiline minRows={3} value={reply} onChange={(e) => setReply(e.target.value)} />
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <FormControlLabel control={<Checkbox checked={internal} onChange={(e) => setInternal(e.target.checked)} />} label="Internal note (not emailed to customer)" />
            <Button variant="contained" onClick={send} disabled={busy || !reply.trim()}>Send</Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
